import { render, staticRenderFns } from "./IntermediateCourse.vue?vue&type=template&id=7c3ac2dc"
import script from "./IntermediateCourse.vue?vue&type=script&lang=js"
export * from "./IntermediateCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports